module.exports = __webpack_public_path__ + "img/bike 3.c1deadd7.svg";